import { render, staticRenderFns } from "./MonitorSelector.vue?vue&type=template&id=2abba522&scoped=true&"
import script from "./MonitorSelector.vue?vue&type=script&lang=js&"
export * from "./MonitorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abba522",
  null
  
)

export default component.exports